import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { Check } from "lucide-react";
import { api } from "../lib/api";
import { STATUS_LABELS } from "../lib/i18n";
import { useLang } from "../context/LangContext";
import { OrderSummary } from "../components/store/OrderSummary";

export const OrderView = ({ order }) => {
  const { t, lang } = useLang();
  const a = order.address;
  return (
    <div className="grid gap-12 lg:grid-cols-12">
      <div className="space-y-8 lg:col-span-7">
        <div className="grid gap-6 border-y border-sand py-6 sm:grid-cols-3">
          <div><p className="text-xs text-sand-dark">{t("order_number")}</p><p data-testid="order-number" className="mt-1 font-latin text-xl">{order.order_number}</p></div>
          <div><p className="text-xs text-sand-dark">{t("status")}</p><p data-testid="order-status" className="mt-1">{STATUS_LABELS[order.status]?.[lang]}</p></div>
          <div><p className="text-xs text-sand-dark">{t("payment_method")}</p><p className="mt-1">{order.payment_method === "online" ? t("online_pay") : t("cod")}</p></div>
        </div>
        <div>
          <p className="mb-2 text-xs tracking-[0.1em] text-sand-dark">{t("delivery_address")}</p>
          <p className="text-sm leading-7">{order.customer.name} — <span dir="ltr">{order.customer.phone}</span><br />
            {[a.city, a.district, a.street, a.building_no, a.postal_code, a.short_address].filter(Boolean).join("، ")}</p>
        </div>
        <ol className="space-y-3">
          {order.status_history.map((h, i) => (
            <li key={i} className="flex items-center gap-3 text-sm">
              <span className="h-2 w-2 rotate-45 bg-gold" />
              <span>{STATUS_LABELS[h.status]?.[lang]}</span>
              <span className="text-xs text-sand-dark">{new Date(h.at).toLocaleString(lang === "ar" ? "ar-SA" : "en-GB")}</span>
            </li>
          ))}
        </ol>
      </div>
      <div className="lg:col-span-5"><OrderSummary quote={order} items={order.items} /></div>
    </div>
  );
};

export default function OrderConfirmation() {
  const { number } = useParams();
  const [sp] = useSearchParams();
  const { t } = useLang();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${number}`, { params: { token: sp.get("token") } }).then((r) => setOrder(r.data)).catch(() => setOrder(false));
  }, [number, sp]);

  if (order === false) return <p className="container-q py-32 text-center font-display text-2xl">{t("not_found")}</p>;
  if (!order) return <div className="container-q py-32" />;

  return (
    <div data-testid="order-confirmation-page" className="container-q pb-28 pt-16">
      <div className="mb-14 max-w-2xl">
        <span className="grid h-14 w-14 place-items-center rounded-full bg-ink text-gold"><Check size={24} strokeWidth={1.4} /></span>
        <h1 className="mt-8 text-4xl sm:text-5xl">{t("order_confirmed")}</h1>
        <p className="mt-4 text-ink/70">{t("thanks")}. {t("confirm_note")} {order.customer.email ? t("email_sent") : ""}</p>
      </div>
      <OrderView order={order} />
      <Link to="/shop/all" className="btn-line mt-14">{t("continue_shopping")}</Link>
    </div>
  );
}
